const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Assessment Scores managers Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('AssessmentScores', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  return $resource(appConfiguration.apiUrl + '/learn/v3/assessment-scores/:subresource/:subname', null, {
    find: {params: {subresource: ''}, method: 'GET', isArray: true},
    get: {params: {subresource: ''}, method: 'GET', isArray: false},
    findByManager: {params: {subresource: 'by-manager'}, method: 'GET', isArray: true},
    findByGrader: {params: {subresource: 'by-grader'}, method: 'GET', isArray: true}
  });
}]);